module.exports = __webpack_public_path__ + "static/img/7-05.a7605c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/7-05.png
// module id = kk61
// module chunks = 1